module.exports = __webpack_public_path__ + "static/img/1045.4a716aa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1045.jpg
// module id = 227
// module chunks = 0